export const projectsQuery = `
*[_type == "project"] | order(_createdAt desc)[0...24]{
  _id,
  title,
  "mainImage": mainImage.asset->url,
  shortDescription,
  fullDescription,
  "images": gallery[].asset->url
}
`;
